import { SegmentedControl } from '@cloudscape-design/components';
import { FC } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { useAuthContext } from '../contexts/AuthContext';
import { Department } from '../models/Tenant';

interface IDepartmentSelector {
  local?: boolean;
  fullName?: boolean;
  departmentState?: string;
  departmentSetState?: (val?: string) => void;
}

const DepartmentSelector: FC<IDepartmentSelector> = ({ departmentState, departmentSetState, local, fullName }) => {
  const { tenantObject, department, setDepartment, userObject, currentUser } = useAuthContext();

  return (
    <Fragment>
      {currentUser &&
        ((tenantObject?.departments?.length ?? 0) > 0 ? (
          <SegmentedControl
            selectedId={local ? (departmentState ?? '') : (department ?? '')}
            options={[
              { id: '', text: 'All' },
              ...(tenantObject?.departments ?? []).map((d: Department) => ({
                // Fallback for old Department as string
                id: typeof d === 'string' ? d : (d.name ?? ''),
                text: typeof d === 'string' ? d : fullName ? d.name : d.displayName,
              })),

              // ...(userObject?.role === 'god' ? [{ id: '__not_set', text: 'Not set' }] : []),
            ]}
            onChange={({ detail }) => {
              local && departmentSetState ? departmentSetState(detail.selectedId) : setDepartment(detail.selectedId);
            }}
          />
        ) : (
          tenantObject?.displayName
        ))}
    </Fragment>
  );
};

export default DepartmentSelector;
